import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { Object3D } from '../core/Object3D.js';

var Scene = /*#__PURE__*/function (_Object3D) {
  _inheritsLoose(Scene, _Object3D);

  function Scene() {
    var _this;

    _this = _Object3D.call(this) || this;
    _this.type = 'Scene';
    _this.background = null;
    _this.environment = null;
    _this.fog = null;
    _this.overrideMaterial = null;
    _this.autoUpdate = true; // checked by the renderer

    if (typeof __THREE_DEVTOOLS__ !== 'undefined') {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
        detail: _assertThisInitialized(_this)
      })); // eslint-disable-line no-undef

    }

    return _this;
  }

  var _proto = Scene.prototype;

  _proto.copy = function copy(source, recursive) {
    _Object3D.prototype.copy.call(this, source, recursive);

    if (source.background !== null) this.background = source.background.clone();
    if (source.environment !== null) this.environment = source.environment.clone();
    if (source.fog !== null) this.fog = source.fog.clone();
    if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
    this.autoUpdate = source.autoUpdate;
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    return this;
  };

  _proto.toJSON = function toJSON(meta) {
    var data = _Object3D.prototype.toJSON.call(this, meta);

    if (this.fog !== null) data.object.fog = this.fog.toJSON();
    return data;
  };

  return Scene;
}(Object3D);

Scene.prototype.isScene = true;
export { Scene };